if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        if (activeMedia.tagName === 'IMG' && window.matchMedia('(max-width: 749px)').matches) {
          const galleryImg =
            this.openedBy?.closest('modal-opener')?.querySelector('.product__media img') ||
            document.querySelector('.product__media-item.is-active .product__modal-opener--image .product__media img');
          if (galleryImg?.complete && galleryImg.naturalWidth > 0) {
            activeMedia.removeAttribute('srcset');
            activeMedia.removeAttribute('sizes');
            activeMedia.src = galleryImg.currentSrc || galleryImg.src;
            if (galleryImg.alt) activeMedia.alt = galleryImg.alt;
          }
        }

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
